import { useEffect } from 'react';
import { useOnboardingGate } from '@/lib/auth/useOnboardingGate';

/**
 * Rendered by the KYC gates instead of the Sumsub runner when the account's
 * signup is unfinished: runs the canonical onboarding gate (which opens the
 * signup funnel at the user's next step) and dismisses the KYC gate. Once
 * signup completes, whatever opened the gate re-triggers it — proactively or
 * via the 403 backstops.
 */
export function KycSignupHandoff({ onClose }: { onClose: () => void }) {
  const ensureOnboarded = useOnboardingGate();

  useEffect(() => {
    ensureOnboarded();
    onClose();
  }, [ensureOnboarded, onClose]);

  return null;
}
